import React, { useState } from "react";
import SectionLabel from "../components/SectionLabel";
import { CLIENTS } from "../data/content";

const ClientCard = ({ client, index }) => {
  const [errored, setErrored] = useState(false);

  return (
    <div
      data-testid={`client-card-${index}`}
      className="aspect-square border-r border-b border-[var(--sifra-line)] relative group cursor-default overflow-hidden bg-white"
    >
      {/* Logo layer (default visible) */}
      <div className="absolute inset-0 flex items-center justify-center p-6 md:p-8 transition-opacity duration-500 group-hover:opacity-0">
        {client.logo && !errored ? (
          <img
            src={client.logo}
            alt={`${client.name} logo`}
            onError={() => setErrored(true)}
            loading="lazy"
            className="max-w-[85%] max-h-[70%] object-contain transition-all duration-500"
          />
        ) : (
          <div className="font-display font-black text-4xl md:text-5xl tracking-tighter text-[var(--sifra-ink)]">
            {client.monogram}
          </div>
        )}
      </div>

      {/* Hover layer — inverted reveal with client name */}
      <div className="absolute inset-0 bg-[var(--sifra-ink)] text-white flex flex-col items-center justify-center p-6 md:p-8 text-center opacity-0 group-hover:opacity-100 transition-opacity duration-500">
        <div className="font-display font-black text-3xl md:text-4xl tracking-tighter">
          {client.monogram}
        </div>
        <div className="mt-3 text-xs md:text-sm font-semibold text-white/80">
          {client.name}
        </div>
      </div>
    </div>
  );
};

const Clients = () => {
  return (
    <>
      <section
        className="border-b border-[var(--sifra-line)] bg-white"
        data-testid="clients-hero"
      >
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-28 grid grid-cols-1 md:grid-cols-12 gap-10 items-end">
          <div className="md:col-span-8">
            <SectionLabel>Client Portfolio</SectionLabel>
            <h1 className="font-display font-black text-4xl sm:text-5xl lg:text-6xl tracking-tighter mt-6 leading-[1]">
              More than fourteen teams.
              <br />
              <span className="text-[var(--sifra-ink-mute)]">
                One reliable partner.
              </span>
            </h1>
          </div>
          <div className="md:col-span-4 text-[var(--sifra-ink-soft)]">
            A sample of organisations that continue to trust Sifra Enterprises
            with their IT hardware procurement and support.
          </div>
        </div>
      </section>

      <section
        className="bg-[var(--sifra-bg)] border-b border-[var(--sifra-line)]"
        data-testid="clients-grid-section"
      >
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-24 md:py-32">
          <div
            className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 border-t border-l border-[var(--sifra-line)] bg-white"
            data-testid="clients-grid"
          >
            {CLIENTS.map((c, i) => (
              <ClientCard key={c.name} client={c} index={i} />
            ))}
            <div
              data-testid="client-card-more"
              className="aspect-square border-r border-b border-[var(--sifra-line)] flex flex-col items-center justify-center p-6 text-center bg-[var(--sifra-ink)] text-white group cursor-default"
            >
              <div className="font-display font-black text-5xl md:text-6xl tracking-tighter">
                14+
              </div>
              <div className="mt-3 text-[10px] tracking-label uppercase text-white/70">
                And many more
                <br />
                trusted clients
              </div>
            </div>
          </div>

          <div className="mt-10 flex items-start gap-4 text-sm text-[var(--sifra-ink-soft)] max-w-2xl">
            <span className="inline-block mt-1 w-1.5 h-1.5 bg-[var(--sifra-accent)]" />
            Brand logos remain the property of their respective owners and are
            shown here to reference past and ongoing engagements only.
          </div>
        </div>
      </section>
    </>
  );
};

export default Clients;
